export class XrtSortExpressions {
  constructor(
    public Column: string,
    public isDescendingSort: boolean,
  ) { }
}
